import type { Locale } from "@/lib/i18n/locale";

export type PlanPriceId = "pro_monthly" | "pro_monthly_usd";

export const PLAN_PRICE_IDS: PlanPriceId[] = ["pro_monthly", "pro_monthly_usd"];

/** Público BR paga em reais; qualquer outro idioma paga em dólar. */
export function planPriceIdFor(locale: Locale): PlanPriceId {
  return locale === "en" ? "pro_monthly_usd" : "pro_monthly";
}

/** Valor formatado do plano Embaixador na moeda do usuário. */
export function planPriceLabel(locale: Locale): string {
  return locale === "en" ? "US$ 4" : "R$ 9,90";
}

/** Valor + periodicidade (ex.: "US$ 4/month"). */
export function planPriceWithPeriod(locale: Locale): string {
  return locale === "en" ? "US$ 4/month" : "R$ 9,90/mês";
}

export function planPeriodSuffix(locale: Locale): string {
  return locale === "en" ? "/ month" : "/ mês";
}
